import React from 'react'
import { Table } from '../Generic'
import { Column } from '@rapiddot/react-virtual-list'


export default class TableList extends React.Component {
  _renderColuns = (columns) => {
    return columns.map((col, index) => {
      const { label, dataKey, sortable, cellRenderer, className, headerCellRenderer } = col;
      return <Column
        key={index}
        label={label}
        dataKey={dataKey}
        sortable={sortable}
        cellRenderer={cellRenderer}
        headerCellRenderer={headerCellRenderer}
        className={className} />
    });
  }

  render() {
    const { columns, stickyStyle, stickyTopOffset, rowHeight } = this.props;

    return (
      <Table
        {...this.props} 
        rowHeight={rowHeight || 40} 
        stickyStyle={stickyStyle}
        stickyTopOffset={stickyTopOffset}
        className="generic-table">
        { this._renderColuns(columns) }
      </Table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Generic/TableList.js